import { render, staticRenderFns } from "./PlantListDetails.vue?vue&type=template&id=64afa312&scoped=true&"
import script from "./PlantListDetails.vue?vue&type=script&lang=ts&"
export * from "./PlantListDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PlantListDetails.vue?vue&type=style&index=0&id=64afa312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64afa312",
  null
  
)

export default component.exports